import React from 'react';
import { IoMdArrowDropupCircle, IoMdArrowDropdownCircle, IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { useFixing } from '../context/FixingGoldContext';

function FixingGold() {
    const {
        isVisible,
        setIsVisible,
        showFixing,
        prezzo,
        variazione,
        prezzoSpot,
        variazioneSpot,
        oraSpot,
        bullBear,
        bullBearSpot,
        loading,
        error,
        handleFixingShow
    } = useFixing();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    /**fixing sparito per miniscreen !!!! */
    return (
        <>
            {(showFixing && prezzo !== "") &&
                <button
                    id="fixing-gold-widget"
                    onClick={handleFixingShow}
                    className={`fixed bottom-4 right-0 ${isVisible ? 'text-start' : 'text-end'} 
                pe-4 py-2 z-important glassmorphism flex flex-row items-center transition-transform duration-300 rounded-l-xl
                ${isVisible ? 'translate-x-0' : 'mini-screen:translate-x-[9rem] translate-x-[12rem] md:translate-x-[21rem]'}`}
                    aria-expanded={isVisible}>
                    {isVisible ? <IoIosArrowForward className='text-white mx-4 mini-screen:mx-2' /> : <IoIosArrowBack className='text-white mx-4 mini-screen:mx-2' />}
                    <div className='md:flex gap-4'>

                        {/* spot */}
                        <div>
                            <p className='text-white font-semibold uppercase mini-screen:text-xs '>Spot {oraSpot}</p>
                            <div className='flex items-center mini-screen:text-xs'>

                                <span className='text-white font-semibold mr-2'>€ {prezzoSpot}</span>
                                <span className={`${bullBearSpot ? 'text-green-600' : 'text-rose-600'} font-semibold mr-2`}>{variazioneSpot}</span>
                                {bullBearSpot ? 
                                    <IoMdArrowDropupCircle className='text-green-600' /> : 
                                    <IoMdArrowDropdownCircle className='text-rose-600' />
                                }
                            </div>
                        </div>

                        {/* fixing del giorno */}
                        <div>
                            <p className='text-white font-semibold uppercase mini-screen:text-xs'>fixing del giorno</p>
                            <div className='flex flex-row items-center mini-screen:text-xs'>
                                <span className={`text-white font-semibold mr-1`}>€ {prezzo}</span> &nbsp;
                                <span className={`font-bold mr ${bullBear ? 'text-green-600' : 'text-rose-600'}`}>{bullBear ? variazione + '%' : variazione + '%'}</span> &nbsp;
                                {bullBear ?
                                    <IoMdArrowDropupCircle className='text-green-600' /> :
                                    <IoMdArrowDropdownCircle className='text-rose-600' />
                                }
                            </div>
                        </div>
                    </div>
                </button>
            }
        </>
    );
}

export default FixingGold;
